import React, { useState, useEffect } from 'react';
import './Buschedule.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const Buschedule = ({ closeBuschedule }) => {
  const [busSchedules, setBusSchedules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const currentDayOfWeek = selectedDate.getDay(); // 0 is Sunday, 1 is Monday

  useEffect(() => {
    const fetchBusSchedules = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'busSchedules'));
        const schedules = querySnapshot.docs.map((doc) => doc.data());
        setBusSchedules(schedules);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchBusSchedules();
  }, []);
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };


  if (loading) {
    return <div style={{color:'#fff'}}>Loading...</div>;
  }

  if (error) {
    return <div style={{color:'#fff'}}>Error fetching bus schedules: {error}</div>;
  }



  const getTodaySchedule = () => {
    const todaySchedule = busSchedules.map((schedule) => ({
      routeNumber: schedule.routeNumber,
      todaySchedule: schedule.schedule[currentDayOfWeek],
    }));

    return todaySchedule;
  };

  const todaySchedule = getTodaySchedule();

  return (
    <div className="buschedule-modal-content">
      <div className="buschedule-header">
        <h2>대구대 버스 시간표</h2>
        <button onClick={closeBuschedule}>&times;</button>
      </div>
      <div className="buschedule-body">
        <div className='aside-body'>
        <div className='calander'>
          <p>날짜 선택:{' '}</p>
          <DatePicker selected={selectedDate} onChange={handleDateChange} />
        </div>

        <p>
          오늘은{' '}
          <span className="redText">
            {selectedDate.toLocaleDateString('ko-KR', {
                  month: 'long',
                  day: 'numeric',
                  weekday: 'long',
                })}
          </span>{' '}
        </p>
        <p>
          {' '}
          <span className="redText">
            대구대(정문1)
          </span>{' '}
          기준
        </p>
            </div>
        
        <table className='bustable' >
          <thead>
            <tr>
              <th>버스번호</th>
              <th>첫차시간</th>
              <th>막차시간</th>
            </tr>
          </thead>
          <tbody>
            {todaySchedule.map((schedule) => (
              <tr key={schedule.routeNumber}>
                <td>{schedule.routeNumber}</td>
                <td>{schedule.todaySchedule.firstBusTime}</td>
                <td>{schedule.todaySchedule.lastBusTime}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Buschedule;
